<template>
  <div>
    <v-row>
      <v-col cols="12" class="pl-0">
        <span class="text-subtitle-2">Informações Imóvel</span>
        <v-divider></v-divider>
      </v-col>
      <v-col cols="3" class="pl-0" v-if="chave !== 21 && chave !== 23">
        <input-text label="Matrícula do Imóvel" v-model="model.NroMatricula" v-mask="maskMatricula" />
      </v-col>
      <v-col v-if="chave === 23" cols="3">
        <input-text label="CEI/CNO" v-model="model.NroCEICNO" v-mask="['############']" :required="chave !== 99" />
      </v-col>
      <v-col v-if="chave === 21" cols="3">
        <input-text label="CIB (Nirf)" v-model="model.NroCIBNirf" v-mask="['#######']" :required="chave !== 99" />
      </v-col>
      <v-col cols="3">
        <input-text label="Nome Cartório" v-model="model.NomeCartorio" />
      </v-col>
      <v-col cols="6">
        <input-text label="Cidade do Cartório" v-model="model.CidadeCartorio" />
      </v-col>
      <v-col cols="3" class="px-0">
        <input-text label="Nº do Cadastro" :rules="validaNroCadastro" maxlength="30"
          v-model="model.NroCadastroCartorio" />
      </v-col>
      <v-col cols="1" class="px-1 mt-4">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="primary" dark v-bind="attrs" v-on="on">
              fa fa-question-circle
            </v-icon>
          </template>
          <span>Nº do Cadastro Nacional de Matrícula ou Nº do Cadastro do Imóvel</span>
        </v-tooltip>
      </v-col>
      <v-col cols="5">
        <input-number label="Área Total do Imóvel" v-model="model.QtdArea" format="decimal" />
      </v-col>
      <v-col cols="3">
        <input-radiogroup name="Unidade de Medida" v-model="model.UnidMedidaArea" row>
          <v-radio value="1">
            <template slot="label">
              <span class="mr-2">m²</span>
            </template>
          </v-radio>
          <v-radio value="2">
            <template slot="label">
              <span class="mr-2">ha</span>
            </template>
          </v-radio>
        </input-radiogroup>
      </v-col>
      <v-col cols="3" class="pl-0">
        <input-cep label="CEP" :required="chave !== 99" :model-names="modelNames" :model-endereco="model"
          :clear-model="true" v-model="model.CEP" />
      </v-col>
      <v-col cols="9" class="pr-0">
        <input-text label="Rua" v-model="model.Logradouro" :required="chave !== 99" />
      </v-col>
      <v-col cols="4" class="pl-0">
        <input-text label="Bairro" v-model="model.Bairro" :required="chave !== 99" />
      </v-col>
      <v-col cols="2">
        <input-number label="Número" v-model="model.NroLogradouro" cep-numero :required="chave !== 99" />
      </v-col>
      <v-col cols="6" class="pr-0">
        <input-text label="Complemento" v-model="model.Complemento" />
      </v-col>
      <v-col cols="4" class="pl-0">
        <input-select label="UF" :options="$aux.UF" item-value="UF" item-text="Nome" v-model="model.UF"
          :required="chave !== 99" />
      </v-col>
      <v-col cols="8" class="pr-0">
        <input-text v-model="model.Cidade" label="Cidade" :required="chave !== 99" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    chave: null,
    value: null,
  },
  data () {
    return {
      modelNames: {
        logradouro: 'Logradouro',
        bairro: 'Bairro',
        uf: 'UF',
        localidade: 'Cidade',
        numero: 'NroLogradouro',
        complemento: 'Complemento'
      },
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    maskMatricula () {
      return Array(20).fill('#').map((el, i) => el.repeat(i + 1));
    },
  },
  methods: {
    validaNroCadastro () {
      const regex = /^[0-9-]{1,30}$/;
      const isValid = this.model.NroCadastroCartorio === '' || regex.test(this.model.NroCadastroCartorio);
      return isValid || 'Apenas números e hífen permitidos, até 30 caracteres';
    },
  }
}
</script>
